import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ui-topbar-left" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ui-topbar-right" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "ui-topbar-count"
}
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-end ui-topbar-menu ui-notif-menu" }
const _hoisted_9 = { class: "ui-topbar-menu-head" }
const _hoisted_10 = { class: "ui-topbar-menu-muted" }
const _hoisted_11 = {
  key: 0,
  class: "ui-topbar-menu-empty"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = {
  class: "ui-topbar-profile",
  type: "button",
  "data-bs-toggle": "dropdown",
  "data-bs-display": "static",
  "aria-expanded": "false"
}
const _hoisted_15 = { class: "ui-topbar-avatar" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "ui-topbar-profile-text" }
const _hoisted_19 = { class: "ui-topbar-name" }
const _hoisted_20 = { class: "ui-topbar-role" }
const _hoisted_21 = { class: "dropdown-menu dropdown-menu-end ui-topbar-menu" }
const _hoisted_22 = { class: "ui-topbar-menu-head ui-topbar-menu-user" }
const _hoisted_23 = { class: "text-truncate" }
const _hoisted_24 = { class: "ui-topbar-menu-online" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccountSwitcher = _resolveComponent("AccountSwitcher")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(['ui-topbar', { sticky: _ctx.isSticky }]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "ui-icon-btn ui-topbar-burger",
        id: "header-burger-menu",
        type: "button",
        "aria-label": _ctx.$t('header.openMenu'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("i", {
          class: "ph ph-list",
          "aria-hidden": "true"
        }, null, -1)
      ]), 8, _hoisted_2),
      _createVNode(_component_router_link, {
        to: "/",
        class: "ui-topbar-brand",
        "aria-label": _ctx.$t('header.home')
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.logoSrc,
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["aria-label"]),
      _createVNode(_component_AccountSwitcher)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_LanguageSwitcher),
      _createVNode(_component_LightDarkSwtichBtn),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "ui-icon-btn ui-topbar-bell",
          type: "button",
          "data-bs-toggle": "dropdown",
          "data-bs-display": "static",
          "aria-expanded": "false",
          "aria-label": _ctx.unread ? _ctx.$t('header.notificationsUnread', { count: _ctx.unread }) : _ctx.$t('header.notifications'),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchNotifications && _ctx.fetchNotifications(...args)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("i", {
            class: "ph ph-bell",
            "aria-hidden": "true"
          }, null, -1)),
          (_ctx.unread)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.unread > 99 ? "99+" : _ctx.unread), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_6),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.notifications")), 1),
            _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(_ctx.unread) + ")", 1),
            (_ctx.unread)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ui-notif-readall",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.readAll && _ctx.readAll(...args)), ["stop"]))
                }, _toDisplayString(_ctx.$t("header.markAllRead")), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.notifications.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("header.noNotifications")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (n) => {
            return (_openBlock(), _createElementBlock("button", {
              key: n.id,
              type: "button",
              class: _normalizeClass(["dropdown-item ui-notif-item", { 'is-unread': !n.read_at }]),
              onClick: ($event: any) => (_ctx.openNotification(n))
            }, [
              _createElementVNode("strong", null, _toDisplayString(n.title), 1),
              _createElementVNode("span", null, _toDisplayString(n.body), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.timeAgo(n.created_at)), 1)
            ], 10, _hoisted_12))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, [
            (_ctx.user?.pic)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.user.pic,
                  width: "36",
                  height: "36",
                  alt: "admin"
                }, null, 8, _hoisted_16))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/images/NoImage.png'),
                  width: "36",
                  height: "36",
                  alt: "admin"
                }, null, 8, _hoisted_17)),
            _cache[6] || (_cache[6] = _createElementVNode("span", {
              class: "ui-topbar-online",
              "aria-hidden": "true"
            }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.user?.name), 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("header.roleClient")), 1)
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("i", {
            class: "ph ph-caret-down ui-topbar-chevron",
            "aria-hidden": "true"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.user?.name), 1),
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("header.onlineAccount")), 1)
          ]),
          _createVNode(_component_router_link, {
            to: "/account-settings",
            class: "dropdown-item"
          }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("i", {
                class: "ph ph-user-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("header.profile")), 1)
            ]),
            _: 1,
            __: [8]
          }),
          _createElementVNode("button", {
            type: "button",
            class: "dropdown-item text-danger",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleLogout()))
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("i", {
              class: "ph ph-sign-out",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("header.logout")), 1)
          ])
        ])
      ])
    ])
  ], 2))
}